<div class="card-container mat-elevation-z1">
    <div class="card-content">
        <div *ngIf="!loading && referringPhysicianView">
            <app-referring-physician-view-component [referringPhysicianView]="referringPhysicianView"></app-referring-physician-view-component>
        </div>
    </div>
</div>
